import { FC, useEffect, useState } from 'react';
import { Wrapper } from 'screens/templates/Lists/ListWrapper/Wrapper.styled';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCommercialRelationFromUrl } from 'utils/getCommercialRelationFromUrl/getCommercialRelationFromUrl';
import { useQueryDocuments } from 'use/documents';
import DocumentContainer from './Components/DocumentContainer/DocumentContainer';
import { googleTagManager } from 'use/gtm';
import { getDocumentExists } from 'api/documents';
import { useQueryProfiles } from 'use/profiles';
import DocumentHeaderTemplate from './Components/Header/DocumentHeader';

const Documents: FC = () => {
  const location = useLocation();
  const commercialRelation = getCommercialRelationFromUrl(location.pathname);
  const { isLoading, data: documents, isError } = useQueryDocuments(commercialRelation!);
  const navigate = useNavigate();
  const [documentExistsError, setDocumentExistsError] = useState(false);
  const { data: profiles } = useQueryProfiles();

  useEffect(() => {
    if (!commercialRelation) {
      navigate('/');
      return;
    }
    getDocumentExists(commercialRelation)
      .then((exists) => {
        if (!exists) {
          navigate('/');
        }
      })
      .catch(() => {
        setDocumentExistsError(true);
      });
  }, [commercialRelation, navigate]);

  useEffect(() => {
    googleTagManager({
      event: 'DocumentPageOpen',
      page: {
        url: `${commercialRelation}/documents`,
      },
    });
  }, [commercialRelation]);

  return (
    <Wrapper>
      <DocumentHeaderTemplate
        sectionName="Documenten"
        commercialRelation={commercialRelation}
        profiles={profiles}
      />
      <DocumentContainer
        documents={documents}
        commercialRelation={commercialRelation!}
        isLoading={isLoading}
        isError={isError || documentExistsError}
      />
    </Wrapper>
  );
};

export default Documents;
